import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../services/locale.service';

@Pipe({
  name: 'localeNumber',
  standalone: false
})
export class LocaleNumberPipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(value: number, decimals: number = 1, alwaysShowDecimals: boolean = false): string {
    if (value === null || value === undefined) {
      return '';
    }

    if (alwaysShowDecimals) {
      return this.localeService.formatNumber(value, decimals);
    }
    
    if (decimals === 1) {
      const hasDecimal = value % 1 !== 0;
      return this.localeService.formatNumber(value, hasDecimal ? 1 : 0);
    }
    
    return this.localeService.formatNumber(value, decimals);
  }
}
